export default __webpack_public_path__ + "static/media/bottom_of_curl.72b4a910.svg";